import * as React from 'react';
import isEqual from 'lodash/isEqual';
import Router from 'next/router';

import { Formik, Field, connect } from 'formik';
import Text from 'components/core/Text';
import Input from '../../../Input';

import { validateName, validateLastName, validateEmail } from '../../../../utils/validation';

import imageUrlGenerator from '../../../../utils/imageUrlGenerator';

import {
  Wrapper,
  Avatar,
  AvatarImageEdit,
  AvatarImage,
  AvatarInput,
  InformationBlock,
  Fieldset,
  SaveButton,
} from './styles';

class Effect extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { formik, onChange } = this.props;
    const { values, touched, errors, isSubmitting } = formik;
    const {
      values: nextValues,
      touched: nextTouched,
      errors: nextErrors,
      isSubmitting: nextIsSubmitting,
    } = nextProps.formik;
    if (nextProps.formik !== formik) {
      onChange(
        {
          values,
          touched,
          errors,
          isSubmitting,
        },
        {
          values: nextValues,
          touched: nextTouched,
          errors: nextErrors,
          isSubmitting: nextIsSubmitting,
        },
      );
    }
  }

  render() {
    return null;
  }
}

const ConnectedEffect = connect(Effect);

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userAvatarPreview: null,
      isUserUpdated: false,
    };
  }

  componentDidMount() {
    const { fetchUser, requestFetchQuestionnaire, requestFetchQuestionnaireAnswers, showModal } =
      this.props;
    const { isUserUpdated } = this.state;

    fetchUser();
    requestFetchQuestionnaire();
    requestFetchQuestionnaireAnswers();

    // @TODO should be to refactor
    const aList = document.querySelectorAll('a');
    Array.from(aList).forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        if (isUserUpdated) {
          showModal('LEAVING_PAGE', { pathname: link.href });
        } else {
          Router.push(link.href);
        }
      });
    });
  }

  shouldComponentUpdate(prevProps, prevState) {
    const { isUserUpdated } = this.state;
    if (!isEqual(prevProps, this.props)) {
      return true;
    }

    if (isEqual(prevProps, this.props) && prevState.isUserUpdated === isUserUpdated) {
      return false;
    }

    if (isEqual(prevProps, this.props) && prevState.isUserUpdated !== isUserUpdated) {
      return true;
    }

    return true;
  }

  // set avatar preview in case is image uploaded
  setAvatarPreview = (file) => {
    const { userAvatarPreview } = this.state;
    if (file) {
      if (userAvatarPreview) {
        URL.revokeObjectURL(userAvatarPreview);
      }

      this.setState({ userAvatarPreview: URL.createObjectURL(file) });
    }
  };

  // get user avatar or set a first characters of user name
  getUserAvatar = (firstName, lastName, picture) => {
    if (picture) {
      return (
        <>
          <AvatarImage style={{ backgroundImage: `url(${picture})` }} />
          <AvatarImageEdit>
            <Text variant="captionSmall" align="center" color="white">
              Update
            </Text>
          </AvatarImageEdit>
        </>
      );
    }
    if (firstName && lastName) {
      return `${firstName[0]}${lastName[0]}`.toUpperCase();
    }
    return (
      <AvatarImageEdit>
        <Text variant="captionSmall" align="center" color="white">
          Update
        </Text>
      </AvatarImageEdit>
    );
  };

  // Only send what changed: the API treats a differing email as an address change and pushes
  // it through to SuperTokens (login) and Bento, so an unchanged one must not be re-sent.
  getDetailsData = (values) => {
    const { user } = this.props;
    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
    };
    const email = (values.email || '').trim().toLowerCase();
    if (email && email !== (user.email || '').toLowerCase()) {
      data.email = email;
    }
    if (values.file) {
      data.file = values.file;
    }
    return data;
  };

  // handle user avatar upload
  handleUpload = (event, setFieldValue) => {
    event.preventDefault();
    const formData = new FormData();

    this.setAvatarPreview(event.currentTarget.files[0]);
    // set key - file to form data
    formData.set('file', event.currentTarget.files[0]);
    // set file field to formik internal state
    setFieldValue('file', formData);
  };

  // handle form submit and request user update
  handleFormSubmit = (values) => {
    const { updateUser } = this.props;
    const data = this.getDetailsData(values);

    updateUser({
      profileEditing: true,
      modal: {
        type: 'PROFILE_EDITING',
        data: { title: "GOT IT! WE'VE UPDATED YOUR PROFILE" },
      },
      data,
    });
  };

  checkIsUserUpdated = (values) => {
    const { user } = this.props;

    if (
      values.firstName !== user.firstName ||
      values.lastName !== user.lastName ||
      (values.email || '').trim().toLowerCase() !== (user.email || '').toLowerCase() ||
      !!values.file
    ) {
      this.setState({ isUserUpdated: true });
    } else {
      this.setState({ isUserUpdated: false });
    }
  };

  renderUser = () => {
    const { userAvatarPreview, isUserUpdated } = this.state;
    const { user, errorOnUpdate, subOtherValidity, otherValidity, isUserUpdating } = this.props;

    if (user) {
      const { firstName, lastName, email, picture } = user;

      return (
        <>
          <Formik
            enableReinitialize
            initialValues={{
              firstName: firstName || '',
              lastName: lastName || '',
              email: email || '',
              file: null,
            }}
            onSubmit={(values) => {
              this.handleFormSubmit(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              // Check form values if full filled and no errors then..
              const isError = !!Object.keys(errors).length;
              // set uploaded picture or get from backend
              const userAvatar =
                userAvatarPreview || imageUrlGenerator(picture, '200x200', '100x100');
              // get is error on update
              const isErrorOnUpdate = errorOnUpdate && errorOnUpdate.length;
              // is some field touched

              return (
                <form onSubmit={handleSubmit}>
                  <ConnectedEffect
                    onChange={(currentFormikState, nextFormikState) => {
                      const { values: valuesInner } = nextFormikState;

                      this.checkIsUserUpdated(valuesInner);
                    }}
                  />
                  <Avatar>
                    <Text variant="displayX">
                      {this.getUserAvatar(user.firstName, user.lastName, userAvatar)}
                    </Text>
                    <AvatarInput
                      type="file"
                      name="avatar"
                      onChange={(event) => {
                        this.handleUpload(event, setFieldValue);
                      }}
                    />
                  </Avatar>
                  <InformationBlock>
                    <Fieldset style={{ marginBottom: '29px' }}>
                      <Field
                        validate={validateName}
                        name="firstName"
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder="First name"
                            label="First name"
                            name="firstName"
                            value={values.firstName || ''}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            meta={{ errors, touched }}
                          />
                        )}
                      />
                      <Field
                        validate={validateLastName}
                        name="lastName"
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder="Last name"
                            label="Last name"
                            name="lastName"
                            value={values.lastName || ''}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            meta={{ errors, touched }}
                          />
                        )}
                      />
                      <Field
                        validate={validateEmail}
                        name="email"
                        render={({ field }) => (
                          <Input
                            {...field}
                            type="email"
                            placeholder="Email"
                            label="Email"
                            name="email"
                            value={values.email || ''}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            errorMessage={errors.email}
                            meta={{ errors, touched }}
                          />
                        )}
                      />
                      {isErrorOnUpdate ? (
                        <Text variant="caption" color="ruby" align="center" mt={5}>
                          {errorOnUpdate}
                        </Text>
                      ) : null}
                    </Fieldset>
                    {isUserUpdated ? (
                      <SaveButton
                        isLoading={isUserUpdating}
                        disabled={isError || !subOtherValidity || !otherValidity}
                        type="submit"
                      >
                        Save changes
                      </SaveButton>
                    ) : null}
                  </InformationBlock>
                </form>
              );
            }}
          </Formik>
        </>
      );
    }

    return 'Loading';
  };

  render() {
    return (
      <>
        <Wrapper>{this.renderUser()}</Wrapper>
      </>
    );
  }
}

export default Person;
